import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'copCurrency',
})
export class CopCurrencyPipe implements PipeTransform {
  transform(price: any): string {
      const decimals = 0;
      price = price?.toString(); // por si pasan un numero en vez de un string
      price = parseFloat(price?.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

      if (Number.isNaN(price) || price === 0) {
          return parseFloat('0').toFixed(decimals);
      }
      price = price.toFixed(decimals);

      const amountParts = price.split('.');
      amountParts[0] = new Intl.NumberFormat('es-CO').format(amountParts[0]);

      return `$${amountParts.join('.')}`;
  }
}
